import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	exportIssuesFlagDownloadErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exportIssuesFlagDownloadErrorTitleIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	exportIssuesFlagDownloadErrorTitle: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-download-flag.export-issues-flag-download-error-title',
		defaultMessage: "We couldn't download your issues",
		description: 'Title of export issues flag when there is an error while downloading the file',
	},
	exportIssuesFlagDownloadErrorTitleIssueTerminologyRefreshM4: {
		id: 'issue-navigator-action-export-issues.export-item.export-issues-task-flag.export-issues-task-download-flag.export-issues-flag-download-error-title-issue-terminology-refresh-m4',
		defaultMessage: "We couldn't download your work items",
		description: 'Title of export issues flag when there is an error while downloading the file',
	},
});
export default messages;
